import React, { useState } from "react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import {stripeKey, ApiBaseUrl, createStripeSessionNewProfessional} from "../../../Utils/Constants";


const SecurePayment = () => {

    const navigation = useNavigate();
    const dispatch = useDispatch();
    
const stripePromise = loadStripe( stripeKey);




    const [creditValues, setCreditDetails] = useState(localStorage.getItem("selectedCredits") || 25);
    const [formData, setFormData] = useState({
        name: "",
        cardNumber: "",
        expiry: "",
        cvv: "",
        address: "",
        city: "",
        state: "",
        zip: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };



  const handleCheckout = async () => {
    const stripe = await stripePromise;

    const response = await axios.post(`${ApiBaseUrl}${createStripeSessionNewProfessional}`, {
      amount: creditValues * 100, // Amount in cents
      currency: "usd",
      // You can add more details here as needed
    },
    {
      headers: {
        Authorization:  `${localStorage.getItem("professionalToken")}`,
      },
    });
    if(response.data.status === true){
     
      //console.log("Redirecting to:",  response.data.data.url);
      window.location.href =  response.data.data.url; // Redirect to Stripe Checkout
    }
    else{
        showToast(response.data.data.message, "error");
    }
}


    return (
        <div className="pro-app-page">
            <div className="custom_container secure-payment-page">
            <div className="back-link">← Back to Selection</div>

            <div className="payment-container">
                {/* Left Section */}
                <div className="payment-form">
                    <div className="form-header">
                        <span className="icon">🔒</span>
                        <h3>Secure Payment</h3>
                    </div>

                    <h4>Card Information</h4>
                    <div className="form-group">
                        <label>Cardholder Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label>Card Number</label>
                        <input
                            type="text"
                            name="cardNumber"
                            value={formData.cardNumber}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Expiry Date</label>
                            <input
                                type="text"
                                name="expiry"
                                value={formData.expiry}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>CVV</label>
                            <input
                                type="text"
                                name="cvv"
                                value={formData.cvv}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <h4>Billing Address</h4>
                    <div className="form-group">
                        <label>Street Address</label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>City</label>
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group small">
                            <label>State</label>
                            <input
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group small">
                            <label>ZIP Code</label>
                            <input
                                type="text"
                                name="zip"
                                value={formData.zip}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <button className="purchase-btn"  onClick={handleCheckout}>
                        Complete Purchase – $25.00
                    </button>
                </div>

                {/* Right Section */}
                <div className="order-summary">
                    <h4>Order Summary</h4>
                    <div className="summary-row">
                        <span>Credits</span>
                        <span>{creditValues}</span>
                    </div>
                    <div className="summary-row">
                        <span>Price per credit</span>
                        <span>$1.00</span>
                    </div>
                    <div className="summary-total">
                        <span>Total</span>
                        <span className="price">${creditValues}.00</span>
                    </div>

                    <div className="summary-secure">
                        <h5>🔒 Secure Payment</h5>
                        <ul>
                            <li>256-bit SSL encryption</li>
                            <li>PCI DSS compliant</li>
                            <li>No card details stored</li>
                            <li>Instant credit delivery</li>
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default SecurePayment;
